import React from 'react';
import { ModalWindowContentStyled } from './styled';
export function MobileWindowContent({ staticModalSize, minHeight, maxHeight, children, }) {
    return (React.createElement(ModalWindowContentStyled, { staticModalSize: staticModalSize, minHeight: minHeight, maxHeight: maxHeight }, children));
}
